import React from "react";
import Layout from './Layout';
import { Family } from "../../components/User/Family";

export const FamilyPage = () => <Layout><Family></Family></Layout> 
  